import React from 'react';
import { Checkbox } from '@sato/components';

import { PaintColorItem } from '../RenovationPaintingKitForm.types';

export const ColorCheckboxCard = ({
  value,
  label,
  hexCode,
}: PaintColorItem) => (
  <label
    key={value}
    className="flex cursor-pointer items-center gap-2 overflow-hidden rounded-sm border border-black-light md:basis-[16.5rem] mdDown:w-full"
  >
    <Checkbox className="ml-2 mr-2 flex-1" label={label} value={value} />

    <div className="h-8 w-8 rounded-sm" style={{ backgroundColor: hexCode }} />
  </label>
);
